// useCurrencyUtils.js
import { useCurrency } from "../context/CurrencyContext";

export const useCurrencyUtils = () => {
  const { currency, convertCurrency, formatCurrency, currencies } = useCurrency();

  const convertPrice = (price, targetCurrency = currency) => {
    if (typeof price !== "number" || isNaN(price)) return 0;
    // Prices are stored in USD in the database (seller enters in USD)
    return convertCurrency(price, "USD", targetCurrency);
  };

  const displayPrice = (amount, code = currency) => {
    return formatCurrency(amount, code);
  };

  // Most useful version – includes currency symbol
  // const displayPriceWithSymbol = (amount, code = currency) => {
  //   if (!amount && amount !== 0) return "—";
  //   const formatted = formatCurrency(amount, code);
  //   const symbol = currencies?.[code]?.symbol || code;
    
  //   // For Arabic RTL languages → symbol after number is often preferred
  //   return `${symbol} ${formatted} `;
  //   // If you prefer symbol before: return `${symbol} ${formatted}`;
  // };
const displayPriceWithSymbol = (amount, code = currency) => {
  if (amount === undefined || amount === null || isNaN(amount)) return "—";

  const formatted = formatCurrency(amount, code);
  const symbol = currencies?.[code]?.symbol || code;

  return (
    <span className="inline-flex items-center gap-1">
      {symbol}
      <span>{formatted}</span>
    </span>
  );
};

 
const getCurrencySymbol = (code = currency) => {
  return currencies?.[code]?.symbol || code;
};

  return {
    convertPrice,
    displayPrice,
    displayPriceWithSymbol,  
   getCurrencySymbol
  };
};